<template>
  <div class="scroll-vertical dashboard-container">
    <tiles v-for="(row,i) in rows" :key="i">
      <div v-for="obj in row" :key="obj.uuid" class="tile is-parent is-4">
        <tile-basic
          class="is-info"
          :values="keyValues(obj)"
          :title="obj.hostName"
          :link="assetLink(obj)"
          :headerImg="img(obj)">
        </tile-basic>
      </div>
    </tiles>
  </div>
</template>

<script>
import _ from 'lodash';
import mixin from '@/mixins/assets';
import Tiles from '@/components/Tiles.vue';
import TileBasic from '@/components//TileBasic.vue';

export default {
  name: 'AsseetsTiles',
  mixins: [mixin],
  components: { Tiles, TileBasic },
  props: {
    assets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: 3,
    };
  },
  computed: {
    rows() {
      return _.chunk(this.assets, this.columns);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
